<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-sync :dataModal="dataModal"/>

    <section>
      <page-header :headerName="'MarQTabs'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="name">Id da empresa</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="name" name="name">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.header" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataMarqTab !== '' && !dataMarqTab.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataMarqTab.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de empresas ({{ dataMarqTab.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> DEVICE ID</th>
                        <th> DEVICE MODEL</th>
                        <th> VERSÃO APP</th>
                        <th> VERSÃO ANDROID</th>
                        <th> TOTAL UPDATES</th>
                        <th> ÚLTIMA ATT</th>
                        <th> CRIADO EM</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataMarqTab">
                        <td>{{ c.deviceId }}</td>
                        <td>{{ c.deviceModel }}</td>
                        <td>{{ c.version }}</td>
                        <td>{{ c.soVersion }}</td>
                        <td>{{ c.totalUpdated }}</td>
                        <td>{{ c.updatedAt | formatFullDate }}</td>
                        <td>{{ c.createdAt | formatFullDate }}</td>
                        <td>
                          <a v-on:click="openModalSync(c)" title="Logs">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import modalSync from "../../modals/modalSync";

import {
  GET_MARQ_TAB
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";

export default {
  name: "marq-tablet-company",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    modalSync
  },
  data() {
    return {
      failRequest: false,
      loadingList: false,
      dataModal: '',
      dataMarqTab: '',
      dataSearch: {
        companyId: '',
        header: 'AAAA'
      },
    }
  },
  methods: {
    getList() {
      this.loadingList = true;
      let url = GET_MARQ_TAB + this.dataSearch.companyId;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
        UTIL_SERVICE.console("RESULT GET_MARQ_TAB:", response.data);

        this.dataMarqTab = response.data;
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    openModalSync(data) {
      this.dataModal = data;

      $("#modalSync").modal();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/marqTabletCompany.vue